import Discord from '@src/components/icons/discord'
import FacebookWhite from '@src/components/icons/facebookWhite'
import Instagram from '@src/components/icons/instagram'
import TelegramWhite from '@src/components/icons/telegramWhite'
import Twitter from '@src/components/icons/twitter'
import { Wrapper } from './SocialButtons.styled'
import WhatsAppIcon from '@src/components/icons/whatsApp'
import LinkedInIcon from '@src/components/icons/linkedIn'
import SocialLink from './SocialLink'
import CoinMarketCap from '@src/components/icons/coinmarketcap'

interface SocialButtonsProps {
  twitterUrl?: string
  discordUrl?: string
  telegramUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  whatsAppUrl?: string
  linkedInUrl?: string
  coinmarketcap?: string
}

const SocialButtons: React.FC<SocialButtonsProps> = ({
  twitterUrl = '',
  discordUrl = '',
  telegramUrl = '',
  facebookUrl = '',
  instagramUrl = '',
  whatsAppUrl = '',
  linkedInUrl = '',
  coinmarketcap = '',
}) => {
  return (
    <Wrapper>
      <SocialLink url={coinmarketcap} title="ConiMarketCap">
        <CoinMarketCap />
      </SocialLink>
      <SocialLink url={twitterUrl} title="Twitter">
        <Twitter />
      </SocialLink>
      <SocialLink url={discordUrl} title="Discord">
        <Discord />
      </SocialLink>
      <SocialLink url={telegramUrl} title="Telegram">
        <TelegramWhite />
      </SocialLink>
      <SocialLink url={facebookUrl} title="Facebook">
        <FacebookWhite />
      </SocialLink>
      <SocialLink url={instagramUrl} title="Instagram">
        <Instagram />
      </SocialLink>
      <SocialLink url={whatsAppUrl} title="WhatsApp">
        <WhatsAppIcon />
      </SocialLink>
      <SocialLink url={linkedInUrl} title="LinkedIn">
        <LinkedInIcon />
      </SocialLink>
    </Wrapper>
  )
}

export default SocialButtons
